import { SearchDriverByCustomerNumberDetailDto } from 'src/types/DriverHubBFFOpenAPI';
import { get } from '../baseClient';

export async function searchByCustomerNumber(baseUri: string, customerNumber: string) {
  return await get<SearchDriverByCustomerNumberDetailDto[]>(`${baseUri}Driver/Search/${customerNumber}`);
}
